import { Text } from '@app/components'
import { toCurrency } from '@app/utils'
import { Menu } from 'antd'
import { useContext, useEffect } from 'react'

import { BalanceContext } from '../fortress/BalanceContext'
import { SidebarAccountFooter } from './SidebarAccountFooter'
import { ITEMS } from './SidebarMenuItems'

export const Sidebar = ({
  onClick,
  router,
  backgroundColor,
  collapsed = false,
}: {
  onClick: (route: string) => void
  router: any
  backgroundColor: any
  collapsed?: boolean
}) => {
  const { balance, fetchAccounts } = useContext(BalanceContext)
  //const { ogp, usa, fetchUserInfo } = useContext(UserInfoContext)

  useEffect(() => {
    fetchAccounts()
  }, [fetchAccounts])

  //console.log('OGP in Sidebar:', ogp)

  const menuItems = ITEMS.filter((item) => !(collapsed && item.key === '3')).map((item) => ({
    icon: item.icon,
    key: item.key,
    label:
      item.key === '3' ? (
        <Text style={{ color: '#d7d7d7', marginLeft: '15px', marginTop: '10px' }}>
          {balance ? toCurrency(balance, true) : '$0.00'}
        </Text>
      ) : (
        item.label
      ),
    onClick: item.key === '3' ? fetchAccounts : () => onClick(item.route),
  }))

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        flex: 1,
        minHeight: 0,
        height: '100%',
        ...backgroundColor,
      }}
    >
      <Menu
        selectedKeys={[router.route.slice(1)]}
        theme={'dark'}
        mode="inline"
        inlineCollapsed={collapsed}
        defaultSelectedKeys={[router.route.slice(1)]}
        items={menuItems}
        style={{ flex: 1, overflow: 'auto', borderInlineEnd: 'none', ...backgroundColor }}
      />
      <SidebarAccountFooter collapsed={collapsed} />
    </div>
  )
}
